<script>
    import hasSelectedProducts from '@/online_booking/new/mixins/hasSelectedProducts.js';
    import find from 'lodash/find';
    import forEach from 'lodash/forEach';
    import Avatar from '@/system/components/global/Avatar';
    import ExpandableText from '@/system/components/global/ExpandableText';
    import CalendarType from '@/core/Calendar/CalendarType';
    import BookSoonestAppointment from '@/online_booking/new/components/appointments/BookSoonestAppointment.vue';
    import Preloader from "@/system/components/global/Preloader";
    import Card from '@/online_booking/new/components/common/Card';
    import PreviousButton from '@/online_booking/new/components/common/PreviousButton';
    import StepCounter from '@/online_booking/new/components/common/StepCounter';
    import BookingFlowStep from '@/online_booking/new/BookingFlowStep.js';
    import { http } from '@/system/http.js';
    import { getQueryParam } from '@/system/helpers';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import { bookingKeys } from '@/online_booking/new/helpers/constants';

    export default {
        data: function () {
            return {
                CalendarType,
                calendars: [],
                calendar: null,
                first_step: true,
                second_step: false,
                loading: false,
                time: null,
                waiting_list_selected: 0,
                soonestLoading: false,
                soonestError: false,
                calendarFromQueryParamLoader: false,
            }
        },

        mixins: [hasSelectedProducts],

        props: {
            id: {
                type: String,
                required: true,
            },

            permalink: {
                type: String,
                required: true,
            },
        },

        beforeUnmount () {
            this.$event_bus.$off('LoadData');
            this.$event_bus.$off('booking-restart');
            this.$event_bus.$off('ProductsShowed');
            this.$event_bus.$off('AddonProductsShowed');
            this.$event_bus.$off('productsChosen');
            this.$event_bus.$off('giftcardSelected');
        },

        mounted() {
            this.$event_bus.$on('LoadData', (data) => {
                this.calendars = data.calendars_for_online_booking;
                this.first_step = (data.online_booking_settings.first_step === BookingFlowStep.Calendar);
                this.second_step = (data.online_booking_settings.second_step === BookingFlowStep.Calendar || (data.online_booking_settings.first_step === BookingFlowStep.Products && data.online_booking_settings.second_step == null));
                this.restart();

                if (this.first_step) {
                    this.preselectCalendar();
                }

                this.setPractitionerView(!!this.practitioner_view_active);
            });

            this.$event_bus.$on('giftcardSelected', async (giftcard) => {
                if (this.first_step && this.id === 'first_step') {
                    await this.getCalendars();
                    this.preselectCalendar();
                }
            });

            this.$event_bus.$on('productsChosen', async () => {
                if (this.second_step && this.id === 'second_step') {
                    this.visible = true;
                    this.active = true;
                    if ($(window).width() < 500) {
                        setTimeout(function(){
                            $('html, body').animate({scrollTop:$('#booking-accordion').offset().top});
                        }, 250);
                    }
                    await this.getCalendars();
                    this.preselectCalendar();
                }
            });

            this.$event_bus.$on('timeSet', async (time, fullyBooked, waitingListSelected, isSoonest) => {
                if (!this.first_step && !this.second_step && this.id === 'third_step') {
                    this.time = time.date;
                    this.waiting_list_selected = 0;

                    if ($(window).width() < 500) {
                       setTimeout(function(){
                           $('html, body').animate({scrollTop:$('#booking-accordion').offset().top});
                        }, 250);
                    }

                    await this.getCalendars(isSoonest);

                    if (!isSoonest) {
                        this.preselectCalendar();
                    }

                    if (this.visibleCalendars.length === 1) {
                        this.calendarClicked(this.visibleCalendars.shift());
                    }
                }
            });

            this.$event_bus.$on('preferredTimeSet', async (selected_time, fullDaySignup, comments, fullyBooked, waitingList) => {
                if (!this.first_step && !this.second_step && this.id == 'third_step') {
                    this.time = selected_time;
                    this.waiting_list_selected = waitingList ? 1 : 0;

                    if ($(window).width() < 500) {
                       setTimeout(function(){
                           $('html, body').animate({scrollTop:$('#booking-accordion').offset().top});
                        }, 250);
                    }

                    await this.getCalendars();
                }
            });

            this.$event_bus.$on('booking-restart', () => {
                this.restart();
            });

            this.$event_bus.$on('ProductsShowed', () => {
                if (!this.first_step) {
                    this.restart();
                }
            });

            this.$event_bus.$on('AddonProductsShowed', () => {
                if (!this.first_step) {
                    this.restart();
                }
            });

            this.$event_bus.$on('TimesShowed', () => {
                if (this.id == 'third_step') {
                    this.restart();
                }
            });

            this.$event_bus.$on('bookSoonest', (soonestData) => {
                this.soonestError = false;
                // if second step == times, then show times
                if (!this.second_step) {
                    this.calendarClicked(soonestData.calendar);
                }
            });
        },

        components: {
            StepCounter,
            PreviousButton,
            Avatar ,
            ExpandableText ,
            BookSoonestAppointment,
            Preloader,
            Card,
        },

        computed : {
            ...mapState('OnlineBooking', [
                'currentStep',
                'onlineBooking2ndStep',
                'calendarsCount',
                'settings',
            ]),
            ...mapGetters('OnlineBooking', ['getPreviousStepId', 'totalStepCount', 'currentStepNumber', 'waitingListOnly']),

            practitioner_view_active() {
                return !find(this.calendars, { type: CalendarType.Standard });
            },

            /**
             * Check if any of the visible calendars belong to practitioners.
             * @returns {boolean}
             */
            show_user_profile_image_on_standard_calendars() {
                // The template will show the practitioners profile image on practitioners calendars, which is why we
                // want to show user profile image on standard calendars, as if they were practitioner calendars.
                // Otherwise, some calendars will have images while others not, and the users might actually
                // be acting as a practitioners themselves, and want to have their profile picture shown.
                return this.visibleCalendars.some((calendar) => calendar.type === CalendarType.Practitioner && calendar.practitioners.length > 0);
            },

            isCalendarStepActive () {
                return this.currentStep === 'calendar' && this.id === this.activeCalendarStep;
            },

            activeCalendarStep () {
                if (this.onlineBooking2ndStep === 'times') {
                    return 'third_step';
                } else if (this.onlineBooking2ndStep === 'calendar') {
                    return 'second_step';
                } else {
                    return 'first_step';
                }
            },

            calendarIdOrSecret() {
                return getQueryParam('calendar');
            },

            calendarLoading () {
                return this.soonestLoading || this.calendarFromQueryParamLoader;
            },

            hideUnavailableCalendars() {
                return this.settings['hide_unavailable_calendars'];
            },

            visibleCalendars () {
                if (this.hideUnavailableCalendars) {
                    return this.calendars.filter(
                        calendar => !calendar.is_selected_time_unavailable
                    );
                }

                return this.calendars;
            },
        },

        methods: {
            ...mapActions('OnlineBooking', ['setCurrentStep', 'setSelectedValue', 'setPractitionerView']),

            text_formatted(text) {
                return text.replace(/\n/g, "<br />");
            },

            restart() {
                this.soonestError = false;

                if (this.first_step && this.id === 'first_step' && this.calendars.length === 1) {
                    this.calendarClicked(this.calendars[0]);
                }

                if (this.first_step && this.id === 'first_step' && this.calendars.length > 1) {
                    this.calendar = null;
                    this.triggerStateChange();
                } else if (!this.first_step && this.id === 'second_step' && this.second_step && this.calendars.length > 1) {
                    this.calendar = null;
                } else if (!this.first_step && this.id == 'third_step' && !this.second_step && this.calendars.length > 1) {
                    this.calendar = null;
                }
            },

            calendarClicked(calendar, soonest = false) {
                if (calendar.is_selected_time_unavailable) {
                    return;
                }

                this.calendar = calendar;

                this.setPractitionerView(calendar.type === CalendarType.Practitioner);

                if (!soonest) {
                    this.$event_bus.$emit('CalendarClicked', calendar);
                }
            },

            async getCalendars(isSoonest) {
                this.loading = true;

                const params = {
                    product_ids: this.selectedProductIds,
                    permalink: this.permalink,
                    time: this.time,
                    waiting_list_selected: this.waiting_list_selected,
                };

                try {
                    const { data } = await http.get('/online_booking/get_calendars_markup', { params });

                    this.calendars = data.calendars_for_online_booking;

                    if (isSoonest) {
                        return;
                    }

                    if (this.calendarsCount === 1) {
                        this.calendarClicked(this.calendars[0]);
                    } else {
                        this.triggerStateChange();
                    }
                } catch ({ error, errorBag }) {
                    console.error(error);
                } finally {
                    this.loading = false;
                }
            },

            preselectCalendar() {
                if (this.calendarIdOrSecret) {
                    forEach(this.calendars, cal => {
                        if (cal.id === parseInt(this.calendarIdOrSecret) || cal.secret === this.calendarIdOrSecret) {
                            this.calendarFromQueryParamLoader = true;
                            setTimeout(() => {
                                this.calendarFromQueryParamLoader = false;
                                this.calendarClicked(cal);
                            }, 1000);
                        }
                    });
                }
            },

            async handleBookSoonest () {
                this.soonestLoading = true;
                this.soonestError = false;
                try {
                    const res = await http.post('/online_booking/getSoonestAvailableTime', {
                        product_ids: this.selectedProductIds,
                        permalink: this.permalink
                    });

                    this.$event_bus.$emit('bookSoonest', {
                        timeData: res.data.available_time,
                        formattedDate: res.data.chosen_date_formatted,
                        calendar: res.data.available_time.calendar,
                    });

                    this.calendarClicked(res.data.available_time.calendar, true);
                } catch (e) {
                    this.soonestError = true;
                } finally {
                    this.soonestLoading = false;
                }
            },

            triggerStateChange () {
                this.setCurrentStep('calendar');
            },
        },

        watch: {
            isCalendarStepActive (newValue) {
                if (newValue) {
                    this.calendar = null;
                    this.$event_bus.$emit('CalendarsShowed');
                    this.soonestError = false;
                    window.location.hash = 'choose-where'; // todo: check if this is really needed once we have removed $collapse.
                }
            },

            calendar (newValue) {
                this.setSelectedValue({
                    key: bookingKeys.CALENDAR,
                    value: newValue?.name || ''
                });
            },

            practitioner_view_active (newValue) {
                this.setPractitionerView(newValue);
            }
        },
    }
</script>

<template>
    <div class="calendar-container" v-if="isCalendarStepActive">
        <card
            class="p-0 rounded-lg overflow-hidden"
            id="choose-calendar-panel"
        >
            <h4 class="section-title">
                <step-counter :current="currentStepNumber" :total="totalStepCount" />
                {{
                    practitioner_view_active
                    ? trans('online_booking.appointments.choose_practitioner')
                    : trans('online_booking.appointments.choose_calendar')
                }}
            </h4>
            <div
                :id="id"
                role="tabpanel"
                aria-labelledby="headingCalendar"
                data-parent="#booking-accordion"
                class="pt-6"
            >
                <div class="panel-body p-0">
                    <div id="choose-product-body">
                        <book-soonest-appointment
                            :loading="calendarLoading"
                            @bookSoonest="handleBookSoonest"
                            :hasError="soonestError"
                            v-if="!waitingListOnly && !practitioner_view_active && second_step"
                        />
                        <preloader v-if="calendarLoading && !practitioner_view_active"></preloader>
                        <div v-else>
                            <div class="practitioner-view px-6"
                                 v-if="practitioner_view_active"
                            >
                                <book-soonest-appointment
                                    @bookSoonest="handleBookSoonest"
                                    :loading="calendarLoading"
                                    viewType="user"
                                    :hasError="soonestError"
                                    v-if="!waitingListOnly && id === 'second_step'"
                                />

                                <preloader v-if="calendarLoading"></preloader>

                                <div v-else class="row flex flex-wrap mb-6 gap-y-6">
                                    <div class="col-xs-12 col-sm-6 flex items-stretch" v-for="calendar in visibleCalendars" :key="calendar.id">
                                        <div class="card-box flex practitioner text-center gap-6 justify-between mb-0">
                                            <div class="flex flex-col gap-6 items-center">
                                                <avatar :url="calendar.practitioners[0].profile_image_url" style="border: 0;" height="60px" width="60px" v-if="calendar.type === CalendarType.Practitioner && calendar.practitioners.length > 0"></avatar>

                                                <div class="practitioner-content">
                                                    <h4 class="m-t-5 m-b-5">{{ calendar.name }}</h4>
                                                    <small class="text-muted m-b-0" v-if="calendar.description" ><expandable-text :content="text_formatted(calendar.description)"></expandable-text></small>
                                                </div>
                                            </div>

                                            <div class="text-center practitioner-btn-wrapper">
                                                <span
                                                    v-if="calendar.is_selected_time_unavailable"
                                                    class="rounded px-2 py-1 text-base bg-grey-400 text-white font-normal"
                                                >
                                                    {{ trans('online_booking.selected_time_not_available') }}
                                                </span>

                                                <ep-button v-else @click.prevent="calendarClicked(calendar)">
                                                    <template v-if="waiting_list_selected">{{ trans('online_booking.submit_for_waiting_list') }}</template>
                                                    <template v-else>{{ trans('online_booking.book_time') }}</template>
                                                </ep-button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <template v-else>
                                <a
                                    v-for="calendar in visibleCalendars"
                                    :key="calendar.id"
                                    class="list-group-item"
                                    :class="{'disabled border-b-1 border-grey-200' : calendar.is_selected_time_unavailable}"
                                    @click.prevent="calendarClicked(calendar)"
                                >
                                    <div class="flex">
                                        <avatar class="m-r-10" style="border: 0;" :url="calendar.practitioners[0].profile_image_url" height="32px" width="32px" v-if="calendar.type == CalendarType.Practitioner && calendar.practitioners.length > 0"></avatar>
                                        <avatar class="m-r-10" style="border: 0;" :url="calendar.user?.profile_image_url" height="32px" width="32px" v-else-if="show_user_profile_image_on_standard_calendars"></avatar>
                                        <div class="flex justify-between flex-1">
                                            <div class="calendar-info">
                                                <h5 class="mt-0 text-left mb-0 flex flex-col gap-3 flex-wrap">
                                                    {{ calendar.name }}
                                                    <span
                                                        v-if="calendar.is_selected_time_unavailable"
                                                        class="rounded px-2 py-1 text-sm bg-grey-400 text-white font-normal"
                                                    >
                                                        {{ trans('online_booking.selected_time_not_available') }}
                                                    </span>
                                                </h5>
                                                <p class="text-muted mb-0 mt-2 text-left" v-if="calendar.description" v-sanitize-html="text_formatted(calendar.description)"></p>
                                                <p class="text-muted mb-0 mt-2 text-left" v-if="calendar.business_location" v-sanitize-html="text_formatted(calendar.business_location)"></p>
                                            </div>
                                            <i class="fa-regular fa-arrow-right self-center" v-show="!calendar.is_selected_time_unavailable"></i>
                                        </div>
                                    </div>
                                </a>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <previous-button
                :class="[{'pt-0': practitioner_view_active}, first_step ? 'p-0' : 'p-6']"
                :previous-step-id="getPreviousStepId" />
        </card>
    </div>
</template>
